import { createAction, props } from '@ngrx/store';
import { NavLink } from '../../models/navLink.interface';
import { OpenedMenuType } from '../../models/opened-menu-type';

export const setNavLinks = createAction('[Navigation] Set Navigation links', props<{ navLinks: NavLink[] }>());
export const selectedMenu = createAction('[MenuSelected] Click Menu', props<{ menuLabel: OpenedMenuType }>());
export const setActivePath = createAction('[Navigation] Set Active Path', props<{ activePath?: string }>());
